export const fontList = [
  { id: 0, label: 'Roboto', hasBold: true, hasItalic: true },
  { id: 1, label: 'Open Sans', hasBold: true, hasItalic: true },
  { id: 2, label: 'Montserrat', hasBold: true, hasItalic: true },
  { id: 3, label: 'Poppins', hasBold: true, hasItalic: true },
  { id: 4, label: 'Nunito', hasBold: true, hasItalic: true },
  { id: 5, label: 'Source Sans Pro', hasBold: true, hasItalic: true },
  { id: 6, label: 'Oxygen', hasBold: true, hasItalic: false },
  { id: 7, label: 'Sora', hasBold: true, hasItalic: false },
  { id: 8, label: 'Hahmlet', hasBold: true, hasItalic: false },
  { id: 9, label: 'Andada Pro', hasBold: true, hasItalic: true },
  { id: 10, label: 'Epilogue', hasBold: true, hasItalic: true },
  { id: 11, label: 'JetBrains Mono', hasBold: true, hasItalic: true },
  { id: 12, label: 'Inter', hasBold: false, hasItalic: false },
  { id: 13, label: 'Encode Sans', hasBold: true, hasItalic: false },
  { id: 14, label: 'Manrope', hasBold: true, hasItalic: false },
  { id: 15, label: 'Lora', hasBold: true, hasItalic: true },
  { id: 16, label: 'Playfair Display', hasBold: true, hasItalic: true },
  { id: 17, label: 'Archivo', hasBold: true, hasItalic: true },
  { id: 18, label: 'Oswald', hasBold: true, hasItalic: false },
  { id: 19, label: 'Cormorant', hasBold: true, hasItalic: true },
];
